const {
    _depositETHForProtectedStaking,
    _depositETHForFeesAndMEV,
    _getListOfLSDNetworks,
    _getLSDNForBLSPublicKey,
    _depositETHByNodeRunner,
    _availableToStake,
    _isBLSPublicKeyBanned,
    _calculateFundsRequiredForStaking,
    _fundNodeOperatorFromGiantSavETHPool,
    _fundNodeOperatorFromGiantFeesAndMevPool,
    _stake,
    _getAllBLSPublicKeysForANodeRunnerInAnLSDNetwork,
    _previewNodeOperatorRewards,
    _getGiantPoolDETHBalance,
    _getUserGiantProtectedStakingLPBalance,
    _getUserGiantFeesAndMevLPBalance,
    _getMinimum,
    _claimFeesAndMevRewards,
    _getProtectedBatchesForDepositor,
    _previewClaimableProtectedStakingLP,
    _claimProtectedStakingRewards,
    _getValidatorsToBeRotated,
    _rotateFundsBackToGiantProtectedStakingPool,
    _rotateFundsBackToGiantFeesAndMevPool,
    _isETHAvailableInProtectedStakingOfSomeLSDN,
    _isETHAvailableInFeesAndMevOfSomeLSDN,
    _getLpTokensDataForClaimRewards,
    _previewFeesAndMevRewards,
    _getLastInteractedTimestamp,
    _isEligibleToInteractWithGiantLPToken,
    _getCumulativeListOfValidators,
    _getCumulativeActivity,
    _getCumulativeHouseCreated,
    _getCumulativeHouseJoined,
    _getCumulativeValidatorsCreated,
    _getCumulativeValidatorIndexes,
    _getCumulativeValidatorIndexDetails,
    _batchDepositNodeOperators,
    _batchStake,
    _batchMintDerivatives,
    _isLSD,
    _executeFunctionAsSmartWallet,
    _applyForDecryptionAsSmartWallet,
    _setNodeRunnerLabel,
    _getSmartWalletLabel,
    _ownerOfLabel,
    _isLabelAlreadyTaken,
    _depositDETHForStaking,
    _getdETHRequiredToIsolateWithdrawnKnot,
    _batchCalculateFundsRequiredForStaking,
    _batchFundNodeOperatorFromGiantSavETHPool,
    _batchFundNodeOperatorFromGiantFeesAndMevPool,
    _getBatchDepositDataFromKeystores,
    _getSafeOwners,
    _getValidatorDetails
} = require("../logic/lsd");

class WizardSubPackage {

	constructor(signer) {
		this.etherSigner = signer;
	}

    depositETHForProtectedStaking(amount) {
        return _depositETHForProtectedStaking(this.etherSigner, amount);
    }

    depositETHForFeesAndMEV(amount) {
        return _depositETHForFeesAndMEV(this.etherSigner, amount);
    }

    getListOfLSDNetworks() {
        return _getListOfLSDNetworks(this.etherSigner);
    }

    getLSDNForBLSPublicKey(blsPublicKey) {
        return _getLSDNForBLSPublicKey(this.etherSigner, blsPublicKey);
    }

    depositETHByNodeRunner(liquidStakingManagerAddress, blsPublicKey, blsSignature, eoaRepresentative, ethAmount) {
        return _depositETHByNodeRunner(this.etherSigner, liquidStakingManagerAddress, blsPublicKey, blsSignature, eoaRepresentative, ethAmount);
    }

    availableToStake() {
        return _availableToStake(this.etherSigner);
    }

    isBLSPublicKeyBanned(liquidStakingManagerAddress, blsPublicKey) {
        return _isBLSPublicKeyBanned(this.etherSigner, liquidStakingManagerAddress, blsPublicKey);
    }

    calculateFundsRequiredForStaking(blsPublicKey) {
        return _calculateFundsRequiredForStaking(this.etherSigner, blsPublicKey);
    }

    fundNodeOperatorFromGiantSavETHPool(liquidStakingManagerAddress, blsPublicKey, amount) {
        return _fundNodeOperatorFromGiantSavETHPool(this.etherSigner, liquidStakingManagerAddress, blsPublicKey, amount);
    }

    fundNodeOperatorFromGiantFeesAndMevPool(liquidStakingManagerAddress, blsPublicKey, amount) {
        return _fundNodeOperatorFromGiantFeesAndMevPool(this.etherSigner, liquidStakingManagerAddress, blsPublicKey, amount);
    }

    stake(liquidStakingManagerAddress, authenticationPackage) {
        return _stake(this.etherSigner, liquidStakingManagerAddress, authenticationPackage);
    }

    getAllBLSPublicKeysForANodeRunnerInAnLSDNetwork(liquidStakingManagerAddress, nodeRunner) {
        return _getAllBLSPublicKeysForANodeRunnerInAnLSDNetwork(this.etherSigner, liquidStakingManagerAddress, nodeRunner);
    }
    
    previewNodeOperatorRewards(syndicateAddress, liquidStakingManagerAddress, nodeRunner, smartWallet) {
        return _previewNodeOperatorRewards(this.etherSigner, syndicateAddress, liquidStakingManagerAddress, nodeRunner, smartWallet);
    }

    getGiantPoolDETHBalance(giantPoolAddress) {
        return _getGiantPoolDETHBalance(this.etherSigner, giantPoolAddress);
    }
    
    getUserGiantProtectedStakingLPBalance(userAddress) {
        return _getUserGiantProtectedStakingLPBalance(this.etherSigner, userAddress);
    }

    getUserGiantFeesAndMevLPBalance(userAddress) {
        return _getUserGiantFeesAndMevLPBalance(this.etherSigner, userAddress);
    }

    getMinimum(value1, value2) {
        return _getMinimum(value1, value2);
    }

    claimFeesAndMevRewards(recipientAddress) {
        return _claimFeesAndMevRewards(this.etherSigner, recipientAddress);
    }

    getProtectedBatchesForDepositor(userAddress, lpTokenStatus) {
        return _getProtectedBatchesForDepositor(this.etherSigner, userAddress, lpTokenStatus);
    }

    previewClaimableProtectedStakingLP(userAddress) {
        return _previewClaimableProtectedStakingLP(this.etherSigner, userAddress);
    }
    
    claimProtectedStakingRewards(userAddress, amount) {
        return _claimProtectedStakingRewards(this.etherSigner, userAddress, amount);
    }

    getValidatorsToBeRotated() {
        return _getValidatorsToBeRotated(this.etherSigner);
    }

    rotateFundsBackToGiantProtectedStakingPool() {
        return _rotateFundsBackToGiantProtectedStakingPool(this.etherSigner);
    }

    rotateFundsBackToGiantFeesAndMevPool() {
        return _rotateFundsBackToGiantFeesAndMevPool(this.etherSigner);
    }

    isETHAvailableInProtectedStakingOfSomeLSDN(requiredProtectedStakingAmount) {
        return _isETHAvailableInProtectedStakingOfSomeLSDN(this.etherSigner, requiredProtectedStakingAmount);
    }

    isETHAvailableInFeesAndMevOfSomeLSDN(requiredFeesAndMevAmount) {
        return _isETHAvailableInFeesAndMevOfSomeLSDN(this.etherSigner, requiredFeesAndMevAmount);
    }

    getLpTokensDataForClaimRewards(tokenType) {
        return _getLpTokensDataForClaimRewards(this.etherSigner, tokenType);
    }

    previewFeesAndMevRewards(userAddress) {
        return _previewFeesAndMevRewards(this.etherSigner, userAddress);
    }

    getLastInteractedTimestamp(userAddress, giantTokenAddress) {
        return _getLastInteractedTimestamp(this.etherSigner, userAddress, giantTokenAddress);
    }

    isEligibleToInteractWithGiantLPToken(lastInteractedTimestamp) {
        return _isEligibleToInteractWithGiantLPToken(this.etherSigner, lastInteractedTimestamp);
    }

    getCumulativeListOfValidators(userAddress) {
        return _getCumulativeListOfValidators(this.etherSigner, userAddress);
    }

    getCumulativeActivity(userAddress) {
        return _getCumulativeActivity(this.etherSigner, userAddress);
    }

    getCumulativeHouseCreated(userAddress) {
        return _getCumulativeHouseCreated(this.etherSigner, userAddress);
    }

    getCumulativeHouseJoined(userAddress) {
        return _getCumulativeHouseJoined(this.etherSigner, userAddress);
    }

    getCumulativeValidatorsCreated(userAddress) {
        return _getCumulativeValidatorsCreated(this.etherSigner, userAddress);
    }

    getCumulativeValidatorIndexes(userAddress) {
        return _getCumulativeValidatorIndexes(this.etherSigner, userAddress);
    }

    getCumulativeValidatorIndexDetails(userAddress) {
        return _getCumulativeValidatorIndexDetails(this.etherSigner, userAddress);
    }

    batchDepositNodeOperators(liquidStakingManagerAddress, batchDepositData, eoaRepresentative, ethAmount) {
        return _batchDepositNodeOperators(this.etherSigner, liquidStakingManagerAddress, batchDepositData, eoaRepresentative, ethAmount);
    }

    batchStake(liquidStakingManagerAddress, authenticationPackages) {
        return _batchStake(this.etherSigner, liquidStakingManagerAddress, authenticationPackages);
    }

    batchMintDerivatives(liquidStakingManagerAddress, authenticatedBalanceReports) {
        return _batchMintDerivatives(this.etherSigner, liquidStakingManagerAddress, authenticatedBalanceReports);
    }

    isLSD(ticker) {
        return _isLSD(this.etherSigner, ticker);
    }

    executeFunctionAsSmartWallet(nodeRunner, targetContractAddress, encodedFunctionData, ethValue) {
        return _executeFunctionAsSmartWallet(this.etherSigner, nodeRunner, targetContractAddress, encodedFunctionData, ethValue);
    }

    applyForDecryptionAsSmartWallet(liquidStakingManagerAddress, blsPublicKey, stakehouseAddress, aesPublicKey, nodeRunner) {
        return _applyForDecryptionAsSmartWallet(this.etherSigner, liquidStakingManagerAddress, blsPublicKey, stakehouseAddress, aesPublicKey, nodeRunner);
    }

    setNodeRunnerLabel(label) {
        return _setNodeRunnerLabel(this.etherSigner, label);
    }

    getSmartWalletLabel(liquidStakingManagerAddress, smartWalletAddress) {
        return _getSmartWalletLabel(this.etherSigner, liquidStakingManagerAddress, smartWalletAddress);
    }

    ownerOfLabel(label) {
        return _ownerOfLabel(this.etherSigner, label);
    }

    isLabelAlreadyTaken(label) {
        return _isLabelAlreadyTaken(this.etherSigner, label);
    }

    depositDETHForStaking(savETHPoolAddress, blsPublicKey, amount) {
        return _depositDETHForStaking(this.etherSigner, savETHPoolAddress, blsPublicKey, amount);
    }

    getdETHRequiredToIsolateWithdrawnKnot(savETHPoolAddress, blsPublicKey) {
        return _getdETHRequiredToIsolateWithdrawnKnot(this.etherSigner, savETHPoolAddress, blsPublicKey);
    }

    batchCalculateFundsRequiredForStaking(blsPublicKeys) {
        return _batchCalculateFundsRequiredForStaking(this.etherSigner, blsPublicKeys);
    }

    batchFundNodeOperatorFromGiantSavETHPool(liquidStakingManagerAddress, blsPublicKeys, amounts) {
        return _batchFundNodeOperatorFromGiantSavETHPool(this.etherSigner, liquidStakingManagerAddress, blsPublicKeys, amounts);
    }

    batchFundNodeOperatorFromGiantFeesAndMevPool(liquidStakingManagerAddress, blsPublicKeys, amounts) {
        return _batchFundNodeOperatorFromGiantFeesAndMevPool(this.etherSigner, liquidStakingManagerAddress, blsPublicKeys, amounts);
    }

    getBatchDepositDataFromKeystores(keystores, keystorePassword) {
        return _getBatchDepositDataFromKeystores(this.etherSigner, keystores, keystorePassword);
    }

    getSafeOwners(safeAddress) {
        return _getSafeOwners(safeAddress);
    }

    getValidatorDetails(blsPublicKey) {
        return _getValidatorDetails(this.etherSigner, blsPublicKey);
    }
}

module.exports = {
    WizardSubPackage
};
